import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import type { CollapsibleSectionProps } from "@/components/sections/CollapsibleSection.types";

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    count,
    open,
    onToggle,
    children,
    className,
    headerClassName,
    contentClassName,
}) => {
    const headerId = React.useId();
    const contentId = React.useId();

    return (
        <div className={cn("w-full", className)}>
            <button
                type="button"
                id={headerId}
                aria-expanded={open}
                {...(open ? { "aria-controls": contentId } : {})}
                onClick={onToggle}
                className={cn(
                    "flex w-full cursor-pointer items-center gap-2 rounded-t border-b border-gray-200 px-2 py-2 text-left text-lg font-semibold transition-colors hover:bg-gray-100",
                    headerClassName
                )}
            >
                <ChevronDown
                    size={18}
                    aria-hidden="true"
                    className={cn("shrink-0 transition-transform", !open && "-rotate-90")}
                />
                <span>{title}</span>
                {count !== undefined && (
                    <span className="text-sm font-normal text-muted-foreground">({count})</span>
                )}
            </button>

            {open && (
                <div
                    id={contentId}
                    role="region"
                    aria-labelledby={headerId}
                    className={cn("pt-4", contentClassName)}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsibleSection;
